/**
 * A module to export enumerations of available actions for GeoApi
 * @module geo/actions
 * @hidden
 * @private
 */

/**
 * Enumerate all available actions with no action on the appStore
 * @since v 2.1.0
 */
export enum TypeKeyUtils {
  UTIL_CONVERT_PROJ = 'UTIL_CONVERT_PROJ'

}

export enum TypeKeyUtilsProxy {


}
